export default "__VITE_ASSET__d2db17db__"